<div [ngStyle]="getBgImage()" class="hero-bg-image">
  <div [ngStyle]="getBgColor()" class="hero-bg-overlay">
    <slot></slot>
  </div>
</div>
